import React from "react";

interface DriveIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

const DriveIcon: React.FC<DriveIconProps> = ({
  size = 24,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 48 48"
    {...props}
  >
    {/* Verde lado izquierdo */}
    <path fill="#34A853" d="M16.5 4L2 28l8 14 14.5-24z" />
    {/* Amarillo lado derecho */}
    <path fill="#FBBC05" d="M31.5 4h-15l14.5 24h15z" />
    {/* Azul abajo */}
    <path fill="#4285F4" d="M2 28l8 14h28l8-14z" />

    {/* Triángulos de intersección */}
    {/* Arriba (verde oscuro) */}
    <path fill="#188038" d="M16.5 4l7.5 13 7.5-13z" />
    {/* Derecha (rojo/naranja) */}
    <path fill="#EA4335" d="M31.5 28l7.5 14 8-14z" />
    {/* Izquierda (azul oscuro, ahora apuntando hacia adentro) */}
    <path fill="#1967D2" d="M2 28l7.5 14 7-14z" />
  </svg>
);

export default DriveIcon;